export { default as SplitSection } from "./SplitSection";
